/**
 * Catalog enums and UI labels for adjustment reasons.
 *
 * Values match backend-2.0 `ReasonsForAdjustment` choices. This screen only
 * creates rows with label "other" and active scope/type values; legacy rows are
 * filtered out after fetch (see catalogQuery.js).
 */

/** Fixed label for motives created from this admin tool. */
export const ADJUSTMENT_REASON_LABEL = 'other';

export const countryOptions = [
  { value: 'cl', label: 'Chile' },
  { value: 'co', label: 'Colombia' },
  { value: 'mx', label: 'Mexico' },
];

export const labelOptions = [{ value: ADJUSTMENT_REASON_LABEL, label: 'Otro' }];

/** Scopes supported in filters and in the create/edit form. */
export const scopeOptions = [
  { value: 'closing_payment', label: 'Pago de cierre' },
  { value: 'monthly_payment', label: 'Pago de mensualidad' },
];

/** Scopes that may exist in DB but are hidden from the table. */
export const activeScopeValues = new Set(scopeOptions.map((option) => option.value));

/** Types supported in filters and in the create/edit form. */
export const typeOptions = [
  { value: 'payment', label: 'Abono' },
  { value: 'discount', label: 'Descuento' },
];

export const roleScopeOptions = [
  { value: 'landlord', label: 'Propietario' },
  { value: 'tenant', label: 'Arrendatario' },
  { value: 'landlord_tenant', label: 'Arrendatario y Propietario' },
];

/** Empty string in UI means "Todos" and triggers fan-out in catalogQuery. */
export const FILTER_DIMENSIONS = ['country', 'scope', 'type', 'role_scope'];

/**
 * Values expanded per dimension when the user selects "Todos".
 * Must stay aligned with the filter <select> options.
 */
export const filterDimensionOptions = {
  country: countryOptions,
  scope: scopeOptions,
  type: typeOptions,
  role_scope: roleScopeOptions,
};

/** Initial filter state when the screen loads (country comes from admin navbar). */
export const createDefaultFilters = (country) => ({
  country,
  scope: 'closing_payment',
  type: 'payment',
  role_scope: 'tenant',
});

export const REQUIRED_FORM_FIELDS = [
  'description',
  'country',
  'scope',
  'type',
  'role_scope',
];
